if (!customElements.get("hero-slider")) {
  class heroSlider extends HTMLElement {
    constructor() {
      super();
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      const waitForSwiper = () => {
        if (typeof Swiper !== 'undefined') {
          this.initSlider();
          window.addEventListener('resize', this.handleResize);
        } else {
          requestAnimationFrame(waitForSwiper);
        }
      };
      waitForSwiper();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      this.destroySliders();
    }

    handleResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        this.reInitSliders();
      }, 300);
    }

    destroySliders() {
      if (this.mediaSwiper) {
        this.mediaSwiper.destroy(true, true);
        this.mediaSwiper = null;
      }
      if (this.contentSwiper) {
        this.contentSwiper.destroy(true, true);
        this.contentSwiper = null;
      }
    }

    reInitSliders() {
      this.destroySliders();
      this.initSlider();
    }

    initSlider() {
      this.contentSlider = this.querySelector(".hero-slider__content-slider");
      this.mediaSlider = this.querySelector(".hero-slider__media-slider");
      this.autoplay = this.mediaSlider.getAttribute('data-autoplay') === 'true';
      this.autoplaySpeed = +this.mediaSlider.getAttribute('data-autoplay-speed');
      this.prevBtn = this.querySelector(".swiper-button-prev");
      this.nextBtn = this.querySelector(".swiper-button-next");
      this.pagination = this.querySelector(".swiper-pagination");

      this.mediaSwiper = new Swiper(this.mediaSlider, {
        spaceBetween: 14,
        slidesPerView: 1,
        grabCursor: true,
        effect: "coverflow",
        autoplay: this.autoplay
          ? {
              delay: this.autoplaySpeed,
            }
          : false,
        speed: 500,
        loop: true,

        on: {
          autoplayTimeLeft: (s, time, progress) => {
            const activeBullet = this.mediaSlider.querySelector('.swiper-pagination-bullet-active');
            if (activeBullet) activeBullet.style.setProperty('--progress', 1 - progress);
          },
          slideChange: () => {
            this.mediaSlider.querySelectorAll('.swiper-pagination-bullet').forEach(item => {
              item.style.setProperty('--progress', 0);
            });
          },
        },

        navigation: {
          nextEl: this.nextBtn,
          prevEl: this.prevBtn,
        },

        pagination: {
          el: this.pagination,
          clickable: true,
        },
      });

      this.contentSwiper = new Swiper(this.contentSlider, {
        slidesPerView: 1,
        autoHeight: true,
        effect: "fade",
        crossFade: true,
        speed: 500,
        loop: true,

        breakpoints: {
          767: {
            autoHeight: false,
          },
        },
      });

      this.mediaSwiper.controller.control = this.contentSwiper;
      this.contentSwiper.controller.control = this.mediaSwiper;
    }
  }

  customElements.define("hero-slider", heroSlider);
}
